const fmt = (n) => `${Number(n || 0).toLocaleString()} RWF`;

// Transparent breakdown of one payment: merchant net + commission shared 50/50.
export const SplitBreakdown = ({ s, title = "Breakdown", tid = "split-breakdown" }) => {
  const rows = [
    ["pays", "Customer pays", s.amount, "text-white font-bold"],
    ["merchant", `Merchant receives (${+(100 - s.commissionPct).toFixed(2)}%)`, s.merchantNet, "text-emerald-300 font-bold"],
    ["commission", `Commission (${s.commissionPct}%)`, s.commission, "text-slate-200"],
    ["bb", "  ↳ B&B KIGALI (50%)", s.bbShare, "text-slate-300"],
    ["besoft", "  ↳ BESOFT (50%)", s.besoftShare, "text-slate-300"],
  ];
  return (
    <div className="rounded-xl border border-[#273042] bg-[#0A0C10] p-4 text-sm" data-testid={tid}>
      <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-2">{title}</div>
      {rows.map(([k, l, v, c]) => (
        <div key={k} className="flex justify-between gap-3 py-1 border-b border-[#1b2230] last:border-0">
          <span className="text-slate-400 whitespace-pre">{l}</span><span className={c} data-testid={`${tid}-${k}`}>{fmt(v)}</span>
        </div>))}
    </div>
  );
};

export const calcSplit = (amount, pct) => {
  const commission = Math.round((amount * pct) / 100);
  const besoftShare = Math.floor(commission / 2);
  return { amount, commissionPct: pct, commission, bbShare: commission - besoftShare, besoftShare, merchantNet: amount - commission };
};
